const PROPERTY_VALUATIONS = {
    liquidity: 'liquidity',
    realEstate: 'realEstate',
    standard: 'standard'
};
export default PROPERTY_VALUATIONS;
